export default __webpack_public_path__ + "static/media/blueTick.614c0421.svg";